var _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2738 20.858H27.6067C20.8969 20.858 16.373 27.8341 19.0162 34.1052C19.3843 34.9788 20.2291 35.5452 21.1638 35.5452H22.8073C23.3613 35.5452 23.8442 35.9286 23.9786 36.4751L26.0944 45.081C26.5356 46.8754 28.1212 48.1343 29.9402 48.1343C31.7593 48.1343 33.3449 46.8754 33.7861 45.081L35.9019 36.4751C36.0363 35.9286 36.5192 35.5452 37.0731 35.5452H38.7167C39.6514 35.5452 40.4961 34.9788 40.8643 34.1052C43.5075 27.8341 38.9836 20.858 32.2738 20.858Z",
    fill: "#8F79D7"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.9402,
    cy: 15.0131,
    rx: 5.84492,
    ry: 5.84492,
    fill: "#8F79D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04915 11.3919L19.272 19.0261",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.567 9.64522C12.567 9.64522 6.67788 10.3028 6.04919 11.3917C5.42051 12.4806 7.79565 17.9095 7.79565 17.9095",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9508 11.3919L40.728 19.0261",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.433 9.64522C47.433 9.64522 53.3221 10.3028 53.9508 11.3917C54.5795 12.4806 52.2043 17.9095 52.2043 17.9095",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.38577 48.6085L18.6086 40.9743",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13201 42.0905C7.13201 42.0905 4.75696 47.5194 5.38562 48.6083C6.01429 49.6972 11.9034 50.3547 11.9034 50.3547",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6142 48.6085L41.3914 40.9743",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.868 42.0905C52.868 42.0905 55.243 47.5194 54.6144 48.6083C53.9857 49.6972 48.0966 50.3547 48.0966 50.3547",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOut);
export default __webpack_public_path__ + "static/media/icon-out.b499e41a8ab3f2d9aedc31d2a6e20ac5.svg";
export { ForwardRef as ReactComponent };